import { CircularProgress, Typography } from '@mui/material';

import { StatePanel } from './StatePanel';

export type LoadingStateProps = {
  message?: string;
};

export const LoadingState = ({ message = 'Loading…' }: LoadingStateProps) => (
  <StatePanel testId="loading-state">
    <CircularProgress size={32} />
    <Typography variant="body2" color="text.secondary">
      {message}
    </Typography>
  </StatePanel>
);
